import { useStatusStyle } from '@europrocurement/l2d-modules/hooks';
import { DossierStatus } from '@europrocurement/l2d-modules/modules/Dossiers';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import React, { useMemo } from 'react';

type DashboardStatCardTotalBarItems = {
    id?: number | null;
    libelle?: string | null;
    childsCount?: number | null;
};

type DashboardStatCardTotalBarProps = {
    items: DashboardStatCardTotalBarItems[];
    title: string;
    icon?: IconProp;
};
const DashboardStatCardTotalBar: React.FunctionComponent<DashboardStatCardTotalBarProps> =
    function ({ items, title, icon }) {
        const { palette } = useTheme();
        const { getDossierStatusStyle } = useStatusStyle();
        const totalItems = useMemo(
            () => items.reduce((sum, item) => sum + (item.childsCount ?? 0), 0),
            [items],
        );

        return (
            <>
                <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="l2dbodys">{title}</Typography>
                        <Typography variant="l2dh4">{totalItems}</Typography>
                    </Box>
                    {icon && (
                        <Box
                            sx={{
                                backgroundColor: palette.background.default,
                                padding: '6px',
                                fontSize: '24px',
                                borderRadius: '8px',
                            }}
                        >
                            <FontAwesomeIcon icon={icon} />
                        </Box>
                    )}
                </Box>
                <Box
                    sx={{ display: 'flex', width: '100%', borderRadius: '8px', overflow: 'hidden' }}
                >
                    {items.map((item) => {
                        const percentage =
                            totalItems > 0 ? ((item.childsCount ?? 0) / totalItems) * 100 : 0;
                        const { sxStatus } = getDossierStatusStyle(item.id as number);

                        return (
                            <Tooltip
                                title={item.libelle}
                                arrow
                                placement="top"
                                key={`status_bar_'${item.id}`}
                            >
                                <Box
                                    sx={{
                                        height: '10px',
                                        width: `${percentage}%`,
                                        ...sxStatus,
                                    }}
                                />
                            </Tooltip>
                        );
                    })}
                </Box>

                <Box sx={{ display: 'flex', width: '100%', gap: '8px' }}>
                    {items.map((item) => {
                        if (item.childsCount && item.childsCount > 0) {
                            return (
                                <Tooltip
                                    title={item.libelle}
                                    arrow
                                    placement="top"
                                    key={`status_total_'${item.id}`}
                                >
                                    <Box>
                                        <DossierStatus
                                            label={item.childsCount.toString()}
                                            statutId={item.id as number}
                                        />
                                    </Box>
                                </Tooltip>
                            );
                        }
                        // eslint-disable-next-line react/jsx-no-useless-fragment
                        return <></>;
                    })}
                </Box>
            </>
        );
    };

export default DashboardStatCardTotalBar;
